/**
 * What a person is in one organization (PD-0033). Serialized as PascalCase strings on the wire
 * (JsonStringEnumConverter). Mirrors the backend ContextKindContract.
 */
export enum ContextKind {
  Instructor = "Instructor",
  Member = "Member",
}
